import "@/reactDomSafety";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

// Benign browser warning — CRA dev overlay treats it as a fatal runtime error.
const RESIZE_OBSERVER_LOOP =
  /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
const REMOVE_CHILD_NOT_FOUND =
  /Failed to execute 'removeChild' on 'Node'/;
window.addEventListener(
  "error",
  (event) => {
    const msg = event.message || "";
    if (RESIZE_OBSERVER_LOOP.test(msg) || REMOVE_CHILD_NOT_FOUND.test(msg)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

serviceWorkerRegistration.register();
